import React from "react";
import Footer from "../components/Footer";
import SharedNavbar from "../components/SharedNavbar";
import "../App.css";
import "./SecurityPage.css"; // Reuse Security Page styles
import TermsOfUse from "./TermsOfUse";

const TermsPage = () => {

  return (
    <div className="security-page">
      {/* Navigation - Identical to SecurityPage */}
      <SharedNavbar />

      {/* Main Content */}
      <div style={{ paddingTop: "2rem" }}>
        <TermsOfUse />
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TermsPage;
